const STORAGE_KEY = 'adwary_last_booking';

export function readLastBooking() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (
      data &&
      typeof data.businessId === 'string' &&
      typeof data.businessName === 'string' &&
      typeof data.reservationTypeId === 'number' &&
      typeof data.reservationTypeName === 'string'
    ) {
      return data;
    }
    return null;
  } catch {
    return null;
  }
}

export function saveLastBooking({ businessId, businessName, reservationTypeId, reservationTypeName }) {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        businessId,
        businessName,
        reservationTypeId,
        reservationTypeName,
        bookedAt: new Date().toISOString(),
      })
    );
  } catch {
    // localStorage unavailable — ignore
  }
}
